export default "__VITE_ASSET__D3u79Wbt__"